import { useSelector } from 'react-redux';
import { UserGroups } from './constants';

const hasGroup = (groups, group) => groups.indexOf(group) !== -1;

export const scheduling = (groups) => {
   const isBackofficeOrSchedulingManager = hasGroup(groups, UserGroups.backoffice) && hasGroup(groups, UserGroups.scheduler);

   return {
      get canCreate() {
         return hasGroup(groups, UserGroups.support)
            || hasGroup(groups, UserGroups.farmer)
            || hasGroup(groups, UserGroups.transporter)
            || hasGroup(groups, UserGroups.client)
            || isBackofficeOrSchedulingManager;
      },

      get canCall() {
        return hasGroup(groups, UserGroups.support)
           || hasGroup(groups, UserGroups.backoffice);
      },

      get canCallMonitor() {
         return hasGroup(groups, UserGroups.scheduler);
       },

      get canSend() {
         return hasGroup(groups, UserGroups.support)
            || hasGroup(groups, UserGroups.backoffice)
            || hasGroup(groups, UserGroups.checkinAgent);
       },

      get canView() {
         return hasGroup(groups, UserGroups.support)
            || hasGroup(groups, UserGroups.farmer)
            || hasGroup(groups, UserGroups.transporter)
            || hasGroup(groups, UserGroups.driver)
            || hasGroup(groups, UserGroups.checkinAgent)
            || hasGroup(groups, UserGroups.client)
            || isBackofficeOrSchedulingManager;
      },

      get canStart() {
         return hasGroup(groups, UserGroups.support) || isBackofficeOrSchedulingManager;
      },

      get canFinish() {
         return hasGroup(groups, UserGroups.support) || isBackofficeOrSchedulingManager;
      },

      get canCheckin() {
         return hasGroup(groups, UserGroups.support)
            || hasGroup(groups, UserGroups.checkinAgent)
            || isBackofficeOrSchedulingManager;
      },

      get canCancel() {
         return hasGroup(groups, UserGroups.support)
            || hasGroup(groups, UserGroups.farmer)
            || hasGroup(groups, UserGroups.transporter)
            || hasGroup(groups, UserGroups.client)
            || isBackofficeOrSchedulingManager;
      }
   };
};

export const usePermissions = () => {
   const userGroups = useSelector(state => state.auth.user?.groups);

   const _ = group => hasGroup(userGroups, group);

   return {
      groups: userGroups,
      hasGroup: _,
      scheduling: { ...scheduling(userGroups) }
   };
};
